// Sokak Kedileri — turuncu kedi yüzü logosu (kullanıcının gönderdiği görsel).
// Lucide ikon imzasıyla uyumlu (size + className + ...rest) ki stat kartında
// mevcut ikonun yerine doğrudan geçebilsin.
//
// PNG'nin zemini açık gri/beyaz olduğu için kartın açık turuncu kutusunda
// kare gibi durmasın diye `mix-blend-mode: multiply` ile zemin kaynaştırılır
// (beyaz → arka planı gösterir, turuncu kedi olduğu gibi kalır).
/**
 * ⚠️ `kirmizi` — MARKANIN KENDİ RENGİ (11 Eyl 2026, kullanıcı kararı).
 *
 * PNG'nin kendisi ZATEN kırmızı-turuncu; aşağıdaki `hue-rotate(14deg)`
 * onu Yapay Zekâ düğmesinin turuncusuna KAYDIRIYOR. Yani "kırmızı sürüm"
 * ayrı bir dosya değil — bu dosyanın FİLTRESİZ hâli.
 *
 * Kullanıcı: *"eskiden tuş için kullandığımız kırmızı versiyonu"* — işte o.
 * `kirmizi` verildiğinde filtre hiç uygulanmıyor.
 */
export default function CatFaceLogo({ size = 18, className = "", kirmizi = false, ...rest }) {
  // Markamız — diğer ikonlardan hafif büyük ama estetik dursun (png içi boşluklu).
  const px = size + 14;
  return (
    <img
      src="/cat-logo.png"
      alt=""
      width={px}
      height={px}
      className={className}
      style={{
        width: px,
        height: px,
        objectFit: "contain",
        mixBlendMode: "multiply",
        // PNG kırmızı-turuncu; Yapay Zeka butonunun turuncusuna kaydır.
        // `kirmizi` ise dokunma — marka kırmızısı olduğu gibi kalsın.
        filter: kirmizi ? undefined : "hue-rotate(14deg) saturate(0.95)",
      }}
      {...rest}
    />
  );
}
